
import { Component, Vue, Prop, Provide } from 'vue-property-decorator';
import ChangeLanguageIconSp from '@/components/ChangeLanguageIconSp.vue';
import ChangeLanguageIconPc from '@/components/ChangeLanguageIconPc.vue';
import { isPC } from '@/util/device';

@Component({
  components: { ChangeLanguageIconSp, ChangeLanguageIconPc }
})
export default class PageHeader extends Vue {
  @Provide() isPC = isPC;

  @Prop({ type: Boolean, default: false })
  displayLanguageIcon!: boolean;
}
